var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25012 2.96405H5.40481V8.24999C5.40481 8.31874 5.46106 8.37499 5.52981 8.37499H6.46731C6.53606 8.37499 6.59231 8.31874 6.59231 8.24999V2.96405H7.75012C7.85481 2.96405 7.91262 2.84374 7.84856 2.76249L6.09856 0.546862C6.08687 0.531922 6.07193 0.519839 6.05487 0.511529C6.03782 0.50322 6.01909 0.498901 6.00012 0.498901C5.98115 0.498901 5.96243 0.50322 5.94537 0.511529C5.92832 0.519839 5.91338 0.531922 5.90168 0.546862L4.15168 2.76093C4.08762 2.84374 4.14543 2.96405 4.25012 2.96405ZM11.7189 7.78124H10.7814C10.7126 7.78124 10.6564 7.83749 10.6564 7.90624V10.3125H1.34387V7.90624C1.34387 7.83749 1.28762 7.78124 1.21887 7.78124H0.281372C0.212622 7.78124 0.156372 7.83749 0.156372 7.90624V11C0.156372 11.2766 0.37981 11.5 0.656372 11.5H11.3439C11.6204 11.5 11.8439 11.2766 11.8439 11V7.90624C11.8439 7.83749 11.7876 7.78124 11.7189 7.78124Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.f590fa8f28ebece03fc5a7231d3ea54b.svg";
export { ForwardRef as ReactComponent };